export function headPressureConvert(
  value: number,
  fromU: string,
  toU: string,
  conds: Record<string, number>
): number {
  const SG = conds.SG ?? 1.0;

  if (fromU === 'psi' && toU === 'ft') return value * 2.31 / SG;
  if (fromU === 'ft' && toU === 'psi') return value * 0.433 * SG;
  if (fromU === 'bar' && toU === 'm') return value * 10.197 / SG;
  if (fromU === 'm' && toU === 'bar') return value * 0.0981 * SG;
  if (fromU === 'kgcm2' && toU === 'm') return value * 10 / SG;
  if (fromU === 'm' && toU === 'kgcm2') return value * 0.1 * SG;
  if (fromU === 'psi' && toU === 'kpa') return value * 6.89476;
  if (fromU === 'kpa' && toU === 'psi') return value / 6.89476;

  throw new Error(`Unsupported: ${fromU} → ${toU}`);
}
